module.exports = __webpack_public_path__ + "img/29.6ee96842.png";